import { useSelector, shallowEqual } from "react-redux";
import { useMemo } from "react";
import { GlobalState } from "../definitions/GlobalState";

const useAppAccessor = () => {
 
  const getControls = useSelector((state: GlobalState) => {
    return state.controls;
  });
  const getAuth = useSelector((state: GlobalState) => {
    return state.application.auth;
  });

  const getMedia = useSelector((state: GlobalState) => {
    return state.media;
  });

  const loginState = useSelector((state: GlobalState) => state.login, shallowEqual);
  
  const getUserData = useMemo(() => {
    return {
      ...loginState,
      client: loginState?.client?.toLowerCase().trim() || '',
      user: loginState?.user ? {
        ...loginState.user,
        publicUserData: loginState.user.publicUserData ? {
          ...loginState.user.publicUserData,
          company_name: loginState.user.publicUserData.company_name?.toLowerCase().trim(),
        } : loginState.user.publicUserData,
      } : loginState?.user,
    };
  }, [loginState]);

  const getLiveMainData = useSelector((state:GlobalState)=>{
    return state.livemain
  })

  const getInteractions = useSelector((state:GlobalState)=>{
    return state.interactionmain
  })
  
  const getMediaSelectedData = useSelector((state: GlobalState) => {
    return state.interaction;
  });

  const getRecordData = useSelector((state: GlobalState) => {
    return state.record;
  });


  return {
    getControls: () => getControls,
    getAuth: () => getAuth,
    getMedia: () => getMedia,
    getUserData:() => getUserData,
    getLiveMainData:() => getLiveMainData,
    getInteractions:() => getInteractions,
    getMediaSelectedData: () => getMediaSelectedData,
    getRecordData: () => getRecordData,
  };
};

export default useAppAccessor;
